// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// Context
import { useModal } from '../../modal/ModalContext';
// Helper
import { getId, getValue } from '../../layout/helper';
import { getUserFromId } from '../helper';

const UserSimpleString = props => {
    const [t] = useTranslation();
    const modal = useModal();
    const users = useSelector(state => state.users.list);
    const user = getUserFromId(users, getId(modal.getItem()));
    const value = getValue(props.value, user);

    return (
        <p className={`info-value ${value ? '' : 'undefined'}`}>
            {value ? t(`users:${value}`) : t('common:undefined')}
        </p>
    );
};

export default UserSimpleString;
